import React from 'react';
import { Link } from 'react-router-dom';
import { IPLTradeLogo } from '../components/Layout';
import { ArrowLeft, Mail, Phone, Code2, Megaphone, BarChart2, Users, Globe } from 'lucide-react';

export default function DeveloperPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)', padding: '2rem 1.5rem' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>

        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.85rem', marginBottom: '2rem' }}>
          <ArrowLeft size={15} /> Back to App
        </Link>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.4rem' }}>
          <IPLTradeLogo size={88} />
        </div>

        {/* Developer card */}
        <div style={{
          background: 'var(--bg-card)', border: '1px solid var(--border)',
          borderRadius: 16, padding: '2rem', marginBottom: '1.5rem',
          display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'flex-start',
        }}>
          {/* Avatar */}
          <div style={{
            width: 72, height: 72, borderRadius: '50%', flexShrink: 0,
            background: 'rgba(245,158,11,0.15)', border: '2px solid rgba(245,158,11,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.6rem',
            color: 'var(--accent)',
          }}>
            RK
          </div>

          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-primary)' }}>
              Ranjan Kumar Basak
            </div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: 4, marginBottom: '1rem' }}>
              Developer &amp; Creator of IPLTrade
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a
                href="mailto:ranjan1991basak@gmail.com"
                style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--text-primary)', textDecoration: 'none', fontSize: '0.88rem' }}
              >
                <span style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Mail size={15} color="#60a5fa" />
                </span>
                ranjan1991basak@gmail.com
              </a>
              <a
                href="tel:+917980973209"
                style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--text-primary)', textDecoration: 'none', fontSize: '0.88rem' }}
              >
                <span style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(16,185,129,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Phone size={15} color="var(--green)" />
                </span>
                +91 79809 73209
              </a>
            </div>
          </div>
        </div>

        {/* Advertising / Promotions */}
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: '1.5rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' }}>
            <Megaphone size={20} color="var(--accent)" />
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', fontWeight: 700 }}>
              Advertising &amp; Promotions
            </h2>
          </div>
          <p style={{ fontSize: '0.87rem', color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '1.25rem' }}>
            IPLTrade reaches thousands of passionate IPL and cricket fans during the tournament season.
            If your brand wants to reach this engaged audience, I'm open to collaboration.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, marginBottom: '1.25rem' }}>
            {[
              { icon: BarChart2, color: '#60a5fa', title: 'Banner ads', desc: 'Prominent placement within the app' },
              { icon: Users, color: 'var(--green)', title: 'Sponsored contests', desc: 'Brand your own contest room' },
              { icon: Megaphone, color: 'var(--accent)', title: 'Announcements', desc: 'Promoted messages to all users' },
              { icon: Globe, color: '#a78bfa', title: 'Social promotions', desc: 'Cross-promotion on social media' },
            ].map(({ icon: Icon, color, title, desc }) => (
              <div key={title} style={{ background: 'var(--bg-secondary)', borderRadius: 10, padding: '12px' }}>
                <Icon size={18} color={color} style={{ marginBottom: 6 }} />
                <div style={{ fontWeight: 600, fontSize: '0.85rem', color: 'var(--text-primary)', marginBottom: 3 }}>{title}</div>
                <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{desc}</div>
              </div>
            ))}
          </div>

          <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: 10, padding: '12px 14px', fontSize: '0.85rem' }}>
            <strong style={{ color: 'var(--accent)' }}>Interested?</strong>
            <span style={{ color: 'var(--text-secondary)', marginLeft: 6 }}>
              Call or WhatsApp <a href="tel:+917980973209" style={{ color: 'var(--accent)', textDecoration: 'none' }}>+91 79809 73209</a> or email{' '}
              <a href="mailto:ranjan1991basak@gmail.com" style={{ color: 'var(--accent)', textDecoration: 'none' }}>ranjan1991basak@gmail.com</a>
            </span>
          </div>
        </div>

        {/* Tech stack */}
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' }}>
            <Code2 size={20} color="var(--blue)" />
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', fontWeight: 700 }}>Built With</h2>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {['React 18', 'Node.js + Express', 'PostgreSQL', 'Recharts', 'Cricbuzz API (RapidAPI)', 'Fast2SMS (OTP)', 'Nodemailer', 'JWT Auth'].map(tech => (
              <span key={tech} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 20, padding: '4px 12px', fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div style={{ marginTop: '2rem', fontSize: '0.75rem', color: 'var(--text-muted)', textAlign: 'center' }}>
          IPLTrade v4 · Made with ♥ for IPL fans · © 2026 Ranjan Kumar Basak
        </div>
      </div>
    </div>
  );
}
